module.exports = __webpack_public_path__ + "img/loading.38e1c64b.gif";